import {ManufacturerDTO} from 'src/app/modules/pbm/models/ManufacturerDTO';
import {Injectable} from '@angular/core';
import {PagedRequestDTO} from 'src/app/modules/common/models/PagedRequestDTO';
import {PagedResponseDTO} from 'src/app/modules/common/models/PagedResponseDTO';
import { HttpClient } from '@angular/common/http';
import {Observable} from 'rxjs';
import {environment} from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ManufacturerService {

  private url = environment.baseUrl + '/manufacturer';

  constructor(private httpClient: HttpClient) {
  }

  getListOfManufacturers(pagedRequestDTO: PagedRequestDTO): Observable<PagedResponseDTO<ManufacturerDTO>> {
    return this.httpClient.post<PagedResponseDTO<ManufacturerDTO>>(this.url + '/filter', pagedRequestDTO);
  }

  saveManufacturer(manufacturerDTO: ManufacturerDTO): Observable<ManufacturerDTO> {
    return this.httpClient.post<ManufacturerDTO>(this.url, manufacturerDTO);
  }

  deleteManufacturer(manufacturerId: number): Observable<{}> {
    return this.httpClient.delete<{}>(this.url + '/' + manufacturerId);
  }

  getManufacturer(manufacturerId: number): Observable<ManufacturerDTO> {
    return this.httpClient.get<ManufacturerDTO>(this.url + '/' + manufacturerId);
  }

}
